export default __webpack_public_path__ + "static/media/fasting_sleep@3x.753de678.jpg";